import React from 'react';

interface IChatBubble {
  fillColor?: string;
  borderColor?: string;
}

const ChatBubble = (props: IChatBubble) => {
  const { fillColor = '#33C85D', borderColor = '#00952a' } = props;
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_2245_29379"
        maskUnits="userSpaceOnUse"
        x="-1"
        y="-1"
        width="18"
        height="18"
        style={{ maskType: 'alpha' }}
      >
        <rect x="-0.5" y="-0.5" width="17" height="17" fill="#D9D9D9" stroke="#00952A" />
      </mask>
      <g mask="url(#mask0_2245_29379)">
        <path
          d="M2.81989 13.8868L4.20678 12.4999H13.333C13.8333 12.4999 14.2741 12.3159 14.6282 11.9618C14.9824 11.6077 15.1663 11.1669 15.1663 10.6666V2.66659C15.1663 2.16626 14.9824 1.7255 14.6282 1.37137C14.2741 1.01723 13.8333 0.833252 13.333 0.833252H2.66634C2.16601 0.833252 1.72525 1.01723 1.37112 1.37137C1.01699 1.7255 0.833008 2.16626 0.833008 2.66659V13.0499C0.833008 13.2769 0.885268 13.5038 1.01651 13.7046C1.14804 13.906 1.33519 14.0448 1.54438 14.1345C1.75375 14.2242 1.98476 14.2642 2.22265 14.2177C2.46018 14.1713 2.65914 14.0476 2.81989 13.8868Z"
          fill={fillColor}
          stroke={borderColor}
        />
        <path d="M4 5H12" stroke="white" strokeLinecap="round" />
        <path d="M4 8H9" stroke="white" strokeLinecap="round" />
      </g>
    </svg>
  );
};

export default ChatBubble;
